// extracted by mini-css-extract-plugin
export default {"disabled":"PromotionStatusBadge_disabled__yTq8s"};